"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlacklistedDepartureDate = exports.ApiPartnerCoefficient = exports.DistanceRangeCoefficient = exports.TimeRangeCoefficient = exports.LastMinuteCoefficient = exports.DEFAULT_BD_LOCATION_RADIUS_IN_METERS = exports.DEFAULT_BD_CUTOFF_IN_HOURS = exports.DEFAULT_BD_MESSAGE = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const transformToDate_1 = require("../transformers/transformToDate");
const resetTime_1 = require("../utils/resetTime");
const MongoMultiPointLocation_1 = require("./MongoMultiPointLocation");
exports.DEFAULT_BD_MESSAGE = "We have a limited number of drivers available for your selected date.";
exports.DEFAULT_BD_CUTOFF_IN_HOURS = 36;
exports.DEFAULT_BD_LOCATION_RADIUS_IN_METERS = 100000;
let VehicleTypeCoefficient = class VehicleTypeCoefficient {
    vehicleType;
    priceAdjustmentCoefficient;
    feeAdjustmentCoefficient;
    unifiedAdjustmentCoefficient = 1; // default value so FE does not need to calculate this
    cutoffInHours = exports.DEFAULT_BD_CUTOFF_IN_HOURS;
};
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.VehicleType),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], VehicleTypeCoefficient.prototype, "vehicleType", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], VehicleTypeCoefficient.prototype, "priceAdjustmentCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], VehicleTypeCoefficient.prototype, "feeAdjustmentCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], VehicleTypeCoefficient.prototype, "unifiedAdjustmentCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)()
    // seems to be only used in flexible offer to check if the offer can be booked
    // in practice only applied for api partners
    ,
    __metadata("design:type", Number)
], VehicleTypeCoefficient.prototype, "cutoffInHours", void 0);
VehicleTypeCoefficient = __decorate([
    (0, type_graphql_1.ObjectType)("VehicleTypeCoefficient")
], VehicleTypeCoefficient);
let LastMinuteCoefficient = class LastMinuteCoefficient {
    hoursFrom;
    hoursTo;
    vehicleTypes = [];
    priceCoefficient;
    feeCoefficient;
    unifiedCoefficient = 1;
    isBlacklisted = false;
};
exports.LastMinuteCoefficient = LastMinuteCoefficient;
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], LastMinuteCoefficient.prototype, "hoursFrom", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], LastMinuteCoefficient.prototype, "hoursTo", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => [legacy_enums_1.VehicleType]),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Array)
], LastMinuteCoefficient.prototype, "vehicleTypes", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], LastMinuteCoefficient.prototype, "priceCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], LastMinuteCoefficient.prototype, "feeCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], LastMinuteCoefficient.prototype, "unifiedCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Boolean)
], LastMinuteCoefficient.prototype, "isBlacklisted", void 0);
exports.LastMinuteCoefficient = LastMinuteCoefficient = __decorate([
    (0, type_graphql_1.ObjectType)("LastMinuteCoefficient")
], LastMinuteCoefficient);
let TimeRangeCoefficient = class TimeRangeCoefficient {
    hourFrom;
    hourTo;
    priceCoefficient;
    feeCoefficient;
    unifiedCoefficient = 1;
    isBlacklisted = false;
};
exports.TimeRangeCoefficient = TimeRangeCoefficient;
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], TimeRangeCoefficient.prototype, "hourFrom", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], TimeRangeCoefficient.prototype, "hourTo", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], TimeRangeCoefficient.prototype, "priceCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], TimeRangeCoefficient.prototype, "feeCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], TimeRangeCoefficient.prototype, "unifiedCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Boolean)
], TimeRangeCoefficient.prototype, "isBlacklisted", void 0);
exports.TimeRangeCoefficient = TimeRangeCoefficient = __decorate([
    (0, type_graphql_1.ObjectType)("TimeRangeCoefficient")
], TimeRangeCoefficient);
let DistanceRangeCoefficient = class DistanceRangeCoefficient {
    distanceFromKm;
    distanceToKm;
    priceCoefficient;
    feeCoefficient;
    unifiedCoefficient = 1;
    isBlacklisted = false;
};
exports.DistanceRangeCoefficient = DistanceRangeCoefficient;
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], DistanceRangeCoefficient.prototype, "distanceFromKm", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], DistanceRangeCoefficient.prototype, "distanceToKm", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], DistanceRangeCoefficient.prototype, "priceCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], DistanceRangeCoefficient.prototype, "feeCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], DistanceRangeCoefficient.prototype, "unifiedCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Boolean)
], DistanceRangeCoefficient.prototype, "isBlacklisted", void 0);
exports.DistanceRangeCoefficient = DistanceRangeCoefficient = __decorate([
    (0, type_graphql_1.ObjectType)("DistanceRangeCoefficient")
], DistanceRangeCoefficient);
let ApiPartnerCoefficient = class ApiPartnerCoefficient {
    apiPartnerIds = [];
    vehicleTypes = [];
    priceCoefficient;
    feeCoefficient;
    unifiedCoefficient = 1;
    isBlacklisted = false;
};
exports.ApiPartnerCoefficient = ApiPartnerCoefficient;
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => [String]),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Array)
], ApiPartnerCoefficient.prototype, "apiPartnerIds", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => [legacy_enums_1.VehicleType]),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Array)
], ApiPartnerCoefficient.prototype, "vehicleTypes", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], ApiPartnerCoefficient.prototype, "priceCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], ApiPartnerCoefficient.prototype, "feeCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], ApiPartnerCoefficient.prototype, "unifiedCoefficient", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Boolean)
], ApiPartnerCoefficient.prototype, "isBlacklisted", void 0);
exports.ApiPartnerCoefficient = ApiPartnerCoefficient = __decorate([
    (0, type_graphql_1.ObjectType)("ApiPartnerCoefficient")
], ApiPartnerCoefficient);
let BlacklistedDepartureDate = class BlacklistedDepartureDate {
    _id = (0, uuid_1.v4)();
    date;
    description;
    message;
    countryIds = [];
    locationIds = [];
    routeIds = [];
    originPolygon;
    destinationPolygon;
    geolocations;
    locationRadiusMeters = 100000;
    /**
     * When isBlacklistedDate is true but there is also priceAdjustmentCoefficient/feeAdjustmentCoefficient
     * then user will get a warning and he can proceed with booking for the increased price on the website.
     * The booking will be created as Accepted. Via Partner API the route will not be available in this case.
     * When isBlacklistedDate is false and there is priceAdjustmentCoefficient/feeAdjustmentCoefficient
     * then the price will be increased without alerting the user. The booking will be created as Confirmed.
     * Via Partner API the route will be available at an increased price.
     */
    isBlacklistedDate = false;
    vehicleCoefficients = [];
    createdAt;
    updatedAt;
    lastMinuteCoefficients = [];
    timeRangeCoefficients = [];
    distanceRangeCoefficients = [];
    apiPartnerCoefficients = [];
    parentDescription;
    static get messagePlaceholder() {
        return exports.DEFAULT_BD_MESSAGE;
    }
    beforeSave() {
        this._id = this._id || (0, uuid_1.v4)();
        this.message = this.message || exports.DEFAULT_BD_MESSAGE;
        this.date = (0, resetTime_1.resetTime)(this.date);
    }
};
exports.BlacklistedDepartureDate = BlacklistedDepartureDate;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], BlacklistedDepartureDate.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    (0, type_graphql_1.Field)(),
    __metadata("design:type", Date)
], BlacklistedDepartureDate.prototype, "date", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], BlacklistedDepartureDate.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], BlacklistedDepartureDate.prototype, "message", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => [String]),
    __metadata("design:type", Array)
], BlacklistedDepartureDate.prototype, "countryIds", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => [String]),
    __metadata("design:type", Array)
], BlacklistedDepartureDate.prototype, "locationIds", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => [String]),
    __metadata("design:type", Array)
], BlacklistedDepartureDate.prototype, "routeIds", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], BlacklistedDepartureDate.prototype, "originPolygon", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], BlacklistedDepartureDate.prototype, "destinationPolygon", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", MongoMultiPointLocation_1.MongoMultiPointLocation)
], BlacklistedDepartureDate.prototype, "geolocations", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], BlacklistedDepartureDate.prototype, "locationRadiusMeters", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    __metadata("design:type", Boolean)
], BlacklistedDepartureDate.prototype, "isBlacklistedDate", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => [VehicleTypeCoefficient]),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => VehicleTypeCoefficient),
    __metadata("design:type", Array)
], BlacklistedDepartureDate.prototype, "vehicleCoefficients", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    (0, type_graphql_1.Field)(),
    __metadata("design:type", Date)
], BlacklistedDepartureDate.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    (0, type_graphql_1.Field)(),
    __metadata("design:type", Date)
], BlacklistedDepartureDate.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => [LastMinuteCoefficient]),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => LastMinuteCoefficient),
    __metadata("design:type", Array)
], BlacklistedDepartureDate.prototype, "lastMinuteCoefficients", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => [TimeRangeCoefficient]),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => TimeRangeCoefficient),
    __metadata("design:type", Array)
], BlacklistedDepartureDate.prototype, "timeRangeCoefficients", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => [DistanceRangeCoefficient]),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => DistanceRangeCoefficient),
    __metadata("design:type", Array)
], BlacklistedDepartureDate.prototype, "distanceRangeCoefficients", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(() => [ApiPartnerCoefficient]),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ApiPartnerCoefficient),
    __metadata("design:type", Array)
], BlacklistedDepartureDate.prototype, "apiPartnerCoefficients", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.MinLength)(1),
    (0, class_transformer_1.Transform)(({ value }) => value?.trim()),
    __metadata("design:type", String)
], BlacklistedDepartureDate.prototype, "parentDescription", void 0);
exports.BlacklistedDepartureDate = BlacklistedDepartureDate = __decorate([
    (0, typeorm_1.Entity)("blacklistedDepartureDates"),
    (0, type_graphql_1.ObjectType)("BlacklistedDepartureDate")
], BlacklistedDepartureDate);
//# sourceMappingURL=BlacklistedDepartureDate.js.map